export default "__VITE_ASSET__DB77mATM__"